export function GET_ORDER_SETTING_REQUEST(state) {
  state;
  state.orderSetting = {
    ...state.orderSetting,
    isLoading: true
  };
}

export function GET_ORDER_SETTING_SUCCESS(state, payload) {
  let data = {
    min_pembelian: '',
    min_qty: null,
    tanpa_validasi: false
  };
  const { orderSettings } = payload.data.data;
  orderSettings.map(item => {
    if (item.nameCode === 'MIN_TOTAL_PRICE') {
      data.min_pembelian = `${item.minValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else if (item.nameCode === 'MIN_ITEM_QTY') {
      data.min_qty = item.minValue
    }
  });
  state;
  state.orderSetting = {
    data: data,
    status: payload.data.data.status,
    isLoading: false
  };
}
export function GET_ORDER_SETTING_ERROR(state, payload) {
  state;
  state.orderSetting = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function UPSERT_ORDER_SETTING_REQUEST(state) {
  state;
  state.orderSetting = {
    ...state.orderSetting,
    isLoading: true
  };
}
export function UPSERT_ORDER_SETTING_SUCCESS(state) {
  state;
  state.orderSetting = {
    ...state.orderSetting,
    isLoading: false
  };
}
export function UPSERT_ORDER_SETTING_ERROR(state, payload) {
  state;
  state.orderSetting = {
    ...state.orderSetting,
    isLoading: false,
    error: true,
    errorMessage: payload
  }
}
